import { useDisclosure } from '@shared/hooks';

import { LatexIcon } from '../icons';
import { LatexEditorModal } from '../latex-editor-modal';

import ControlButton from './control-button';

export default function RichTextEditorLatexControl() {
  const [isLatexModalOpen, latexModalHandlers] = useDisclosure(false);
  const { open: openLatexModal, close: closeLatexModal } = latexModalHandlers;

  const handleOpen = () => {
    openLatexModal();
  };

  const handleClose = () => {
    closeLatexModal();
  };

  return (
    <>
      <ControlButton aria-label='Insert Latex' data-rich-text-editor-control onClick={handleOpen}>
        <LatexIcon />
      </ControlButton>
      <LatexEditorModal open={isLatexModalOpen} onClose={handleClose} />
    </>
  );
}
